import { render, staticRenderFns } from "./waitDispatch.vue?vue&type=template&id=e81fed3e&scoped=true&"
import script from "./waitDispatch.vue?vue&type=script&lang=js&"
export * from "./waitDispatch.vue?vue&type=script&lang=js&"
import style0 from "./waitDispatch.vue?vue&type=style&index=0&id=e81fed3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81fed3e",
  null
  
)

export default component.exports